import { render } from "./TemporalWarning.vue?vue&type=template&id=6c5e7838&ts=true"
import script from "./TemporalWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemporalWarning.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/TemporalWarning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c5e7838"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c5e7838', __exports__)) {
    api.reload('6c5e7838', __exports__)
  }
  
  module.hot.accept("./TemporalWarning.vue?vue&type=template&id=6c5e7838&ts=true", () => {
    api.rerender('6c5e7838', render)
  })

}


export default __exports__